import CryptoJS from "crypto-js";

const SECRET_KEY = "G7vR8sXq!zP4m@L2uYw#9eT0dKfNjCb";

export const generateShortKey = (length = 18) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};

export const encryptString = (text, secret = SECRET_KEY) => {
  return CryptoJS.AES.encrypt(text, secret).toString();
};

export const decryptString = (ciphertext, secret = SECRET_KEY) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secret);
  return bytes.toString(CryptoJS.enc.Utf8);
};
